<template>
  <div id="ranking" class="people">
    <section id="wrapper">
      <header>
        <div class="inner">
          <h2>Hall of Fame</h2>
          <p>Classifica marcatori</p>
        </div>
      </header>
      <div class="wrapper">
        <div class="inner">
          <section class="person_list">
            <div class="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th>marcatore</th>
                    <th style="text-align: center">gol</th>
                    <th style="text-align: center">stagione</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, index) in ranking.players" :key="p.person_id">
                    <td class="person_ranking">{{ index + 1 }}</td>
                    <td class="person_image">
                      <img
                        :srcset="image_urls(people[p.person_id].image)"
                        :src="image_url(people[p.person_id].image)"
                        :alt="person_name(people[p.person_id])"
                      />
                    </td>
                    <td class="person_info">
                      <b>{{ person_name(people[p.person_id]) }}</b>
                      <br />
                      <a
                        v-if="people[p.person_id].url"
                        :href="info_url + people[p.person_id].url"
                        target="_blank"
                      >
                        <i class="fa fa-info-circle" />info
                      </a>
                    </td>
                    <td class="person_score">
                      <b>{{ p.score }}</b>
                    </td>
                    <td class="person_variation">
                      {{ p.variation > 0 ? '(+' + p.variation + ')' : '---' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="align-center table_info">
              classifica aggiornata al
              {{ new Date(ranking.last_update).toLocaleDateString('en-GB') }} <br /><br />
              nella classifica sono presenti i giocatori con un numero di gol maggiore o uguale a 3
            </p>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

import peopleData from '../data/people.json';
import rankingData from '../data/ranking.json';
import { usePersonDisplay, info_url } from '../composables/usePersonDisplay';
import { usePeopleIndex } from '../composables/usePeopleIndex';
import type { People, RankingData } from '../types';

useHead({ title: 'Classifica' });

const people = usePeopleIndex(peopleData as People);
const ranking = rankingData as RankingData;

const { image_urls, image_url, person_name } = usePersonDisplay();
</script>

<style scoped>
/* spostare in css condiviso */
.people .wrapper .inner {
  padding: 0.5em;
}
.people select {
  margin-bottom: 2em;
}
.people table td {
  vertical-align: middle;
  padding: 1em 0.5em;
}
.person table td.person_ranking {
  width: 2rem;
}
.people table td.person_image {
  width: 10em;
}
.people table td.person_image img {
  width: 8em;
}
.people table td.person_info a {
  font-size: 0.8rem;
}
.people table td.person_info a i {
  margin-right: 0.5em;
}
.people table td.person_score {
  text-align: center;
}
.people table td.person_variation {
  text-align: center;
}

@media (max-width: 480px) {
  .people table td.person_image {
    width: 7em;
  }
  .people table td.person_image img {
    width: 5em;
  }
}
</style>
